import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { LegsShapeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import { tableRectangleTrayShapeDimension } from './common/fieldsTrayShapeDimension';
import {
    getMaterialsWithExceptions,
    allMetals,
    allSolidWoods,
    allRecycledWoods,
} from './common/materialGroups';
import { fieldsLegsDimension } from './common/fieldsLegsDimension';
import { allLegs, getLegsWithExceptions } from './common/shapesGroups';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const tableVintageForm: IForm = {
    formId       : PublishedFormId.TableVintage,
    type         : FormTypeId.Table,
    thumbnailURL : '/resized-images/forms/tableVintage.jpg',
    imagesURLs   : [
        '/resized-images/forms/description/tableVintage/tableVintage1.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage2.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage3.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage4.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage5.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage6.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage7.jpg',
        '/resized-images/forms/description/tableVintage/tableVintage8.jpg',
    ],
    fieldsOrder: [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.TrayShapeDimension,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.LegsShape,
        IFormFieldKey.LegsMaterial,
        IFormFieldKey.LegsDimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        trayShapeDimension : tableRectangleTrayShapeDimension,
        trayMaterial       : {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions([
                    ...allSolidWoods,
                    ...allRecycledWoods,
                ],
                [
                    MaterialId.BlackLocust,
                    MaterialId.Iroko,
                    MaterialId.Douglas,
                    MaterialId.DouglasRecycled,
                    MaterialId.Redcedar,
                    MaterialId.RedcedarRecycled,
                    MaterialId.Padouk,
                    MaterialId.PadoukRecycled,
                    MaterialId.Walnut,
                    MaterialId.WalnutRecycled,
                    MaterialId.Ash,
                    MaterialId.AshRecycled,
                    MaterialId.AshOlive,
                    MaterialId.AshOliveRecycled,
                    MaterialId.Chestnut,
                    MaterialId.ChestnutRecycled,
                    MaterialId.Pine,
                    MaterialId.PineRecycled,
                    MaterialId.Acacia,
                    MaterialId.AcaciaRecycled,
                    MaterialId.Mahogany,
                    MaterialId.MahoganyRecycled,
                    MaterialId.Beech,
                    MaterialId.BeechRecycled,
                    MaterialId.Elm,
                    MaterialId.ElmRecycled,
                    MaterialId.Alderwood,
                    MaterialId.AlderwoodRecycled,
                    MaterialId.Birch,
                    MaterialId.BirchRecycled,
                    MaterialId.Maple,
                    MaterialId.MapleRecycled,
                    MaterialId.Teak,
                    MaterialId.TeakRecycled,
                    MaterialId.Wenge,
                    MaterialId.WengeRecycled,
                    MaterialId.Cherrywood,
                    MaterialId.CherrywoodRecycled,
                    MaterialId.Ebony,
                    MaterialId.EbonyRecycled,
                    MaterialId.Rubber,
                    MaterialId.RubberRecycled,
                    MaterialId.DriftWood,
                    MaterialId.DriftWoodRecycled,
                    MaterialId.Garapa,
                ]),
                required: true,
            },
        },
        legsShape: {
            value   : undefined,
            options : getLegsWithExceptions(allLegs,
                [
                    LegsShapeId.LegsMonastery,
                    LegsShapeId.LegsTrapezeInverted,
                    LegsShapeId.LegsRightCrossPiece,
                    LegsShapeId.LegsScandinavian,
                    LegsShapeId.LegsSquareCrossPiece,
                    LegsShapeId.LegsTrestleCross,
                    LegsShapeId.LegsTrapezeCentral,
                    LegsShapeId.LegsVShaped,
                    LegsShapeId.LegsVShapedCentral,
                    LegsShapeId.LegsUShapedStrengthened,
                    LegsShapeId.LegsTrapeze,
                ]),
            required: true,
        },
        legsMaterial: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allMetals,
                        ...allSolidWoods,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Ash,
                        MaterialId.AshOlive,
                        MaterialId.Chestnut,
                        MaterialId.Pine,
                        MaterialId.Rust,
                        MaterialId.Brass,
                        MaterialId.SheetMetal,
                        MaterialId.StainlessSteel,
                        MaterialId.Zinc,
                        MaterialId.Mahogany,
                        MaterialId.Elm,
                        MaterialId.Alderwood,
                        MaterialId.Birch,
                        MaterialId.Ebony,
                        MaterialId.Garapa,
                    ],
                ),
                required: true,
            },
        },
        legsDimension  : fieldsLegsDimension,
        additionalData : additionalDataFactory({
            budgetMin          : 1200,
            budgetMax          : 18000,
            budgetDefaultValue : 2500,
            marks              : budgetMarksBuilder(1200, 100, 6000, 500, 18000),
        }),
        contact: fieldsContact,
    },
};

export default tableVintageForm;
